import Vue from 'vue';
import Vuetify from 'vuetify';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    dark: localStorage.getItem('dark-mode') === 'true',
    themes: {
      light: {
        primary: '#3a4ee7', // #E53935
        secondary: '#3a4ee7', // #FFCDD2
        accent: '#F7B141', // #3F51B5,
        info: '#abcaf7',
        background: '#EDF1F4',
      },
      dark: {
        primary: '#3a4ee7', // #E53935
        secondary: '#3a4ee7', // #FFCDD2
        accent: '#F7B141', // #3F51B5
        info: '#abcaf7',
        background: '#F7B141',
      },
    },
  },
});
